/**
 * Created by prog2 on 25/10/2018.
 */

import castellano from './castellano';
import english from './english';
import français from './français';
import deutsch from './deutsch';
import portugues from './portugues';
import koreano from './koreano';
import chino from './chino';

const messages = {
    Español: castellano,
    English: english,
    Français: français,
    Deutsch: deutsch,
    Português: portugues,
    한국어: koreano,
    官話: chino,
}

export default messages;



// WEBPACK FOOTER //
// ./src/data/i18n/i18n.js